import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../containers/Layout';
export default function ErrorPageContent(props) {
    const { t } = useTranslation();
    const { match } = props;
    const code = props?.code ? props.code : 404;
    return (_jsx(Layout, { title: t(`httpErrors.${code}title`), match: match, children: _jsxs("div", { className: 'content content--error-page mt-5', children: [_jsx("span", { className: 'content__picture', children: "\u00A0" }), _jsx("h2", { className: 'content__title', children: t(`httpErrors.${code}title`) }), _jsx("p", { className: 'content__text', children: t(`httpErrors.${code}description`) })] }) }));
}
